import { Routes } from '@angular/router';
import { AppLayout } from '@/layout/components/app.layout';
import { Notfound } from '@/pages/notfound/notfound';
import { AuthLayout } from '@/layout/components/app.authlayout';
import { StoricoComponent } from '@/pages/storico/storico.component';
import { MainComponent } from '@/core/main.component';
import { ProfileComponent } from '@/pages/profile/profile.component';
import { AnagraficaComponent } from '@/pages/anagrafica/anagrafica.component';
import { AnagraficaFormComponent } from '@/pages/anagrafica-form/anagrafica-form.component';
import { SchedeInterventiComponent } from '@/pages/scheda-interventi/scheda-interventi.component';
import { SchedeL94Component } from '@/pages/scheda-l94/scheda-l94.component';
import { SchedaL94FormComponent } from '@/pages/scheda-l94-form/scheda-l94-form.component';
import { SchedaInterventiFormComponent } from '@/pages/scheda-interventi-form/scheda-interventi-form.component';
import { Deviatoi } from '@/pages/deviatoi/deviatoi.components';
import { DettaglioDeviatoioComponent } from '@/pages/dettaglio-deviatoio/dettaglio-deviatoio.component';
import { authGuard, authGuardChild } from '@/core/guards/auth.guard';

export const appRoutes: Routes = [
    // ✅ Wrapping globale nel MainComponent
    {
        path: '',
        component: MainComponent,
        children: [
            {
                path: '',
                component: AppLayout,
                canActivate: [authGuard],
                canActivateChild: [authGuardChild],
                children: [
                    { path: '', redirectTo: 'misurazioni', pathMatch: 'full' },
                    {
                        path: 'anagrafica',
                        data: { breadcrumb: 'Anagrafica' },
                        children: [
                            { path: '', component: AnagraficaComponent },
                            { path: 'cliente/nuovo', component: AnagraficaFormComponent, data: { breadcrumb: 'Nuovo cliente', tipo: 'cliente' } },
                            { path: 'cliente/:id', component: AnagraficaFormComponent, data: { breadcrumb: 'Cliente', tipo: 'cliente' } },
                            { path: 'fornitore/nuovo', component: AnagraficaFormComponent, data: { breadcrumb: 'Nuovo fornitore', tipo: 'fornitore' } },
                            { path: 'fornitore/:id', component: AnagraficaFormComponent, data: { breadcrumb: 'Fornitore', tipo: 'fornitore' } }
                        ]
                    },
                    { path: 'profilo', component: ProfileComponent, data: { breadcrumb: 'Profilo' } },
                    {
                        path: 'anagrafica-deviatoi',
                        data: { breadcrumb: 'Anagrafica deviatoi' },
                        children: [
                            { path: '', component: Deviatoi },
                            {
                                path: 'nuovo',
                                loadComponent: () => import('@/pages/anagrafica-deviatoio-form/anagrafica-deviatoio-form.component').then((c) => c.AnagraficaDeviatoioFormComponent),
                                data: { breadcrumb: 'Nuovo' }
                            },
                            {
                                path: ':id',
                                loadComponent: () => import('@/pages/anagrafica-deviatoio-form/anagrafica-deviatoio-form.component').then((c) => c.AnagraficaDeviatoioFormComponent),
                                data: { breadcrumb: 'Modifica' }
                            }
                        ]
                    },
                    {
                        path: 'misurazioni',
                        data: { breadcrumb: 'Misurazioni' },
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('@/pages/misurazioni/misurazioni-list.component').then((c) => c.MisurazioniListComponent)
                            },
                            {
                                path: 'storico/:id',
                                component: StoricoComponent,
                                data: { breadcrumb: 'Storico deviatoio' }
                            },
                            {
                                path: ':id',
                                component: DettaglioDeviatoioComponent,
                                data: { breadcrumb: 'Misurazione' }
                            }
                        ]
                    },
                    {
                        path: 'scheda-l94',
                        data: { breadcrumb: 'Tolleranze L94' },
                        children: [
                            { path: '', component: SchedeL94Component },
                            { path: 'nuovo', component: SchedaL94FormComponent, data: { breadcrumb: 'Nuovo' } },
                            { path: ':id', component: SchedaL94FormComponent, data: { breadcrumb: 'Dettaglio' } }
                        ]
                    },
                    {
                        path: 'scheda-interventi',
                        data: { breadcrumb: 'Scheda interventi' },
                        children: [
                            { path: '', component: SchedeInterventiComponent },
                            { path: 'nuovo', component: SchedaInterventiFormComponent, data: { breadcrumb: 'Nuovo' } },
                            { path: ':id', component: SchedaInterventiFormComponent, data: { breadcrumb: 'Dettaglio' } }
                        ]
                    },
                    {
                        path: 'storico',
                        component: StoricoComponent,
                        data: { breadcrumb: 'Storico' }
                    }
                    /*{
                        path: 'interfaccia-gis',
                        component: Deviatoi,
                        data: { breadcrumb: 'Interfaccia GIS' },
                    }*/
                ]
            }
        ]
    },

    {
        path: 'auth',
        component: AuthLayout,
        children: [{ path: 'login', loadComponent: () => import('@/pages/auth/login').then((c) => c.Login) }]
    },
    { path: 'notfound', component: Notfound },
    { path: '**', redirectTo: '/notfound' }
];
